'use client';

import { useRef, type PropsWithChildren } from 'react';

import { initializeStore, Provider, StoreInterface, StoreType } from '@/stores/store';

export type PreloadedStoreInterface = {
  initialData?: Partial<Omit<StoreInterface, 'updateData'>>;
};

let counter = 0;

export default function StoreProvider({
  children,
  ...props
}: PropsWithChildren<PreloadedStoreInterface>) {
  console.log('StoreProvider', ++counter);

  const storeRef = useRef<StoreType>(undefined);

  if (!storeRef.current) {
    storeRef.current = initializeStore(props);
  }

  return <Provider value={storeRef.current}>{children}</Provider>;
}
